import React, { useState, setState } from 'react';
// import pic1 from "../images/45.png";
import "./chat.css";
// import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
// import AttachFileIcon from '@mui/icons-material/AttachFile';
// import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
// import InputAdornment from '@mui/material/InputAdornment';
// import IconButton from '@mui/material/IconButton';
// import { TextField } from '@mui/material';
// import ChatNameList from './ChatNameList';
//import { faEllipsisV } from '@fortawesome/free-solid-svg-icons/faEllipsisV';
// import Text from './text';
// import ReplyText from './reply_text';
// import NavbarInfluencer from './NavbarInfluencer';
import Nav from './chat_components/nav/Nav';
import ChatBody from './chat_components/chatBody/ChatBody';

function Chat() {


  return (

      <div className="__main">
        <Nav />
        <ChatBody />
      </div>




      
   
  );

}


export default Chat